import { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const PortalContext = createContext<string>('body');

/**
 * @example
 *
 * ```tsx
 * const MyComponent = () => (
 *   <Suspense>
 *     <PortalContext value="#portal">
 *       <Portal>
 *         <dialog>hello world</dialog>
 *       </Portal>
 *     </PortalContext>
 *   </Suspense>
 * )
 * ```
 */
export const Portal = ({ children }: { children?: ReactNode }) => {
  const portal = useContext(PortalContext);
  const [documentMounted, setDocumentMounted] = useState(false);
  useEffect(() => {
    setDocumentMounted(true);
  }, []);

  if (!documentMounted) return null;
  const el = document.querySelector(portal);
  if (!el) throw new Error(`No element of '${portal}'`);
  return createPortal(children, el);
};
